'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onInsert"];
import PropTypes from 'prop-types';
import { PopoverType } from '../../constants/popover';
import AnchorPopoverBodyControls from './AnchorPopoverBodyControls';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  onInsert: PropTypes.func.isRequired
};
function AnchorPopoverBodyInsert(props) {
  const {
      onInsert
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(AnchorPopoverBodyControls, Object.assign({}, rest, {
    popoverType: PopoverType.INSERT,
    onSubmit: onInsert
  }));
}
AnchorPopoverBodyInsert.propTypes = propTypes;
AnchorPopoverBodyInsert.displayName = 'AnchorPopoverBodyInsert';
export default AnchorPopoverBodyInsert;